import React from "react";
import LocaleContext from "./LocaleContext.js";
const LocaleProvider = (props) => {
    const { locale, isRTL } = props;
    return (React.createElement(LocaleContext.Provider, { value: { isRTL: isRTL || false, locale: locale } }, props.children));
};
export default LocaleProvider;
